import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getReturns } from "../../api/apiReturns";

export const useGetReturns = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["returns", params, i18next.language],
        queryFn: () => getReturns(params),
        keepPreviousData: true,
    });

    // The API returns one of:
    //   { data: [...] }                                        → flat list
    //   { data: { data: [...], meta: {...} } }                 → laravel paginator
    //   { data: { data: [...] } }                              → wrapped without meta
    const root = data?.data;
    let returns = [];
    let meta = data?.meta;

    if (Array.isArray(root)) {
        returns = root;
    } else if (root && Array.isArray(root.data)) {
        returns = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        returns,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: returns.length },
        refetch,
    };
};
